<ph-dialog #dialog [open]="open" icon="shield-check" heading="Approval required" (ph-close)="closed.emit()">
    <p class="message">{{ message }}</p>

    <ph-actions slot="footer">
        <ph-button type="button" (click)="closed.emit()">Got it</ph-button>
    </ph-actions>
</ph-dialog>
